module.exports = "data:text/x-markdown;base64,VGhpcyBpcyBhIGNvaW4gZmxpcHBpbmcgZ2FtZSB3aGVyZSB5b3UgbmVlZCB0byBidWlsZCB1cCB5b3VyIHdpbm5pbmcgc3RyZWFrIGJ5IGd1ZXNzaW5nIHRoZSBvdXRjb21lIG9mIGEgY29pbiBmbGlwLiBUbyBjb21wbGV0ZSB0aGlzIGxldmVsIHlvdSdsbCBuZWVkIHRvIHVzZSB5b3VyIHBzeWNoaWMgYWJpbGl0aWVzIHRvIGd1ZXNzIHRoZSBjb3JyZWN0IG91dGNvbWUgMTAgdGltZXMgaW4gYSByb3cuCg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/coinflip.md
// module id = 1357
// module chunks = 0